var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlika(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 36,
    viewBox: "0 0 219 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0365 0.320801H52.3222V9.72379L61.2174 0.320801H65.251L57.4776 8.36116L65.598 19.0197H61.6181L55.2339 10.6051L52.3222 13.5969V19.0197H49.0365V0.320801Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9374 0.320801H72.2231V16.0278H82.0535V19.0197H68.9374V0.320801Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7339 19.0197H90.0193V0.320801H86.7339V19.0197Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2793 0.320801H98.5647V9.72379L107.46 0.320801H111.494L103.72 8.36116L111.841 19.0197H107.861L101.476 10.6051L98.5647 13.5969V19.0197H95.2793V0.320801Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.212 11.5934L123.979 4.11399L120.774 11.5934H127.212ZM122.51 0.1875H125.555L133.783 19.0199H130.31L128.414 14.5054H119.572L117.649 19.0199H114.283L122.51 0.1875Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.665 3.36582H144.735V0.320801H159.908V3.36582H153.978V19.0197H150.665V3.36582Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.519 9.67012C181.519 4.35423 185.499 0 191.162 0C194.608 0 196.692 1.20236 198.482 2.91172L196.371 5.34261C194.876 3.95353 193.273 3.01857 191.136 3.01857C187.556 3.01857 184.965 5.95728 184.965 9.67012C184.965 13.3298 187.556 16.3217 191.136 16.3217C193.433 16.3217 194.902 15.3867 196.505 13.8908L198.615 16.0278C196.665 18.0577 194.528 19.34 191.029 19.34C185.579 19.34 181.519 15.0929 181.519 9.67012Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.595 0.320801H205.881V8.0943H214.803V0.320801H218.089V19.0197H214.803V11.1393H205.881V19.0197H202.595V0.320801Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.915 11.0593H176.577V8.12085H163.915V11.0593Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.915 19.02H177.913V16.0815H163.915V19.02Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.915 3.25924H177.779V0.320801H163.915V3.25924Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.211 11.0511C138.449 11.0511 137.83 10.4315 137.83 9.6698C137.83 8.90835 138.449 8.28882 139.211 8.28882C139.972 8.28882 140.592 8.90835 140.592 9.6698C140.592 10.4315 139.972 11.0511 139.211 11.0511Z",
    fill: "#2E83B9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9697 8.87085H19.0809V0.179932H15.9697V8.87085Z",
    fill: "#2E83B9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1288 20.0304H35.8197V16.9209H27.1288V20.0304Z",
    fill: "#2E83B9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2178 10.5848L29.3618 4.43921L31.5622 6.63804L25.4166 12.7837L23.2178 10.5848Z",
    fill: "#2E83B9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 33.4275L12.642 20.7842H0.148945V17.1453H18.8564V35.8514H15.2159V23.3581L2.57578 36.0001L0 33.4275Z",
    fill: "#2E83B9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2178 26.3679L25.4166 24.1675L31.562 30.3128L29.3618 32.5136L23.2178 26.3679Z",
    fill: "#2E83B9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48779 6.63804L5.68825 4.43921L11.8339 10.5848L9.63314 12.7837L3.48779 6.63804Z",
    fill: "#2E83B9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7699 32.0967C48.7699 30.1283 50.2156 28.3855 52.3683 28.3855C53.5782 28.3855 54.3268 28.7341 55.0442 29.3388L54.5213 29.9537C53.9676 29.4721 53.3527 29.1337 52.3376 29.1337C50.7486 29.1337 49.6107 30.4769 49.6107 32.0967C49.6107 33.8085 50.7075 35.0799 52.4504 35.0799C53.2706 35.0799 54.0294 34.7621 54.5213 34.3622V32.5784H52.3376V31.8506H55.3006V34.7108C54.6341 35.3053 53.6295 35.8079 52.4196 35.8079C50.1644 35.8079 48.7699 34.1674 48.7699 32.0967Z",
    fill: "#2E83B9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2286 28.5085H60.0387V34.9364H64.078V35.6849H59.2286V28.5085Z",
    fill: "#2E83B9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4285 32.0967C73.4285 30.4667 72.2394 29.1337 70.5991 29.1337C68.9588 29.1337 67.7902 30.4459 67.7902 32.0967C67.7902 33.7267 68.9793 35.0594 70.6196 35.0594C72.2599 35.0594 73.4285 33.7473 73.4285 32.0967ZM66.9496 32.0967C66.9496 30.1181 68.4361 28.3855 70.6198 28.3855C72.8035 28.3855 74.2695 30.0973 74.2695 32.0967C74.2695 34.0754 72.7827 35.8079 70.5993 35.8079C68.4156 35.8079 66.9496 34.0959 66.9496 32.0967Z",
    fill: "#2E83B9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2937 34.9573C82.3803 34.9573 83.0571 34.4754 83.0571 33.6554C83.0571 32.8761 82.4008 32.4249 81.1502 32.4249H78.8844V34.9573H81.2937ZM81.0066 31.7071C81.9804 31.7071 82.6572 31.2665 82.6572 30.4052C82.6572 29.698 82.0932 29.2366 81.0681 29.2366H78.8844V31.7071H81.0066ZM78.0848 28.5085H81.1398C81.9598 28.5085 82.6161 28.7341 83.016 29.144C83.3133 29.4516 83.4771 29.831 83.4771 30.3126C83.4771 31.2457 82.9032 31.7273 82.3392 31.9737C83.1903 32.23 83.8773 32.7219 83.8773 33.7268C83.8773 34.9569 82.8417 35.6849 81.2731 35.6849H78.0848V28.5085Z",
    fill: "#2E83B9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.244 33.0601L90.6137 29.3999L88.9734 33.0601H92.244ZM90.2447 28.4568H91.0037L94.274 35.6847H93.4025L92.5617 33.7878H88.6559L87.8049 35.6847H86.9744L90.2447 28.4568Z",
    fill: "#2E83B9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7919 28.5085H98.6016V34.9364H102.641V35.6849H97.7919V28.5085Z",
    fill: "#2E83B9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.49 35.6849H112.3V28.5085H111.49V35.6849Z",
    fill: "#2E83B9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.665 32.0967C122.665 30.4667 121.476 29.1337 119.835 29.1337C118.195 29.1337 117.026 30.4459 117.026 32.0967C117.026 33.7267 118.216 35.0594 119.856 35.0594C121.496 35.0594 122.665 33.7473 122.665 32.0967ZM116.186 32.0967C116.186 30.1181 117.673 28.3855 119.856 28.3855C122.04 28.3855 123.506 30.0973 123.506 32.0967C123.506 34.0754 122.019 35.8079 119.836 35.8079C117.652 35.8079 116.186 34.0959 116.186 32.0967Z",
    fill: "#2E83B9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.726 29.2568H126.316V28.5085H131.955V29.2568H129.546V35.6849H128.726V29.2568Z",
    fill: "#2E83B9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.282 34.6393L140.784 34.0443C141.533 34.7211 142.25 35.0594 143.244 35.0594C144.208 35.0594 144.844 34.5468 144.844 33.8188C144.844 33.1526 144.485 32.7732 142.978 32.4556C141.327 32.0967 140.569 31.5635 140.569 30.3642C140.569 29.2363 141.563 28.406 142.927 28.406C143.972 28.406 144.721 28.7031 145.449 29.2875L144.977 29.913C144.311 29.3696 143.644 29.1337 142.906 29.1337C141.973 29.1337 141.379 29.6464 141.379 30.3126C141.379 30.9893 141.748 31.3685 143.326 31.7068C144.926 32.0554 145.664 32.6399 145.664 33.7575C145.664 34.9877 144.639 35.7872 143.214 35.7872C142.076 35.7872 141.143 35.4081 140.282 34.6393Z",
    fill: "#2E83B9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.579 32.0967C155.579 30.4667 154.39 29.1337 152.749 29.1337C151.109 29.1337 149.941 30.4459 149.941 32.0967C149.941 33.7267 151.13 35.0594 152.77 35.0594C154.41 35.0594 155.579 33.7473 155.579 32.0967ZM149.1 32.0967C149.1 30.1181 150.586 28.3855 152.77 28.3855C154.954 28.3855 156.42 30.0973 156.42 32.0967C156.42 34.0754 154.933 35.8079 152.75 35.8079C150.566 35.8079 149.1 34.0959 149.1 32.0967Z",
    fill: "#2E83B9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.235 28.5085H161.045V34.9364H165.084V35.6849H160.235V28.5085Z",
    fill: "#2E83B9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.366 32.6809V28.5085H169.176V32.6296C169.176 34.1779 169.996 35.0492 171.37 35.0492C172.692 35.0492 173.533 34.2494 173.533 32.6809V28.5085H174.343V32.6194C174.343 34.7108 173.143 35.7974 171.349 35.7974C169.576 35.7974 168.366 34.7108 168.366 32.6809Z",
    fill: "#2E83B9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.26 29.2568H177.85V28.5085H183.489V29.2568H181.08V35.6849H180.26V29.2568Z",
    fill: "#2E83B9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.181 35.6849H187.991V28.5085H187.181V35.6849Z",
    fill: "#2E83B9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.356 32.0967C198.356 30.4667 197.167 29.1337 195.527 29.1337C193.887 29.1337 192.718 30.4459 192.718 32.0967C192.718 33.7267 193.907 35.0594 195.547 35.0594C197.188 35.0594 198.356 33.7473 198.356 32.0967ZM191.877 32.0967C191.877 30.1181 193.364 28.3855 195.547 28.3855C197.731 28.3855 199.197 30.0973 199.197 32.0967C199.197 34.0754 197.71 35.8079 195.527 35.8079C193.343 35.8079 191.877 34.0959 191.877 32.0967Z",
    fill: "#2E83B9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.012 28.5085H203.771L208.292 34.2597V28.5085H209.081V35.6849H208.436L203.802 29.8002V35.6849H203.012V28.5085Z",
    fill: "#2E83B9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.743 34.6393L213.245 34.0443C213.994 34.7211 214.711 35.0594 215.706 35.0594C216.669 35.0594 217.305 34.5468 217.305 33.8188C217.305 33.1526 216.946 32.7732 215.439 32.4556C213.789 32.0967 213.03 31.5635 213.03 30.3642C213.03 29.2363 214.024 28.406 215.388 28.406C216.433 28.406 217.182 28.7031 217.91 29.2875L217.438 29.913C216.772 29.3696 216.106 29.1337 215.367 29.1337C214.434 29.1337 213.84 29.6464 213.84 30.3126C213.84 30.9893 214.209 31.3685 215.788 31.7068C217.387 32.0554 218.125 32.6399 218.125 33.7575C218.125 34.9877 217.1 35.7872 215.675 35.7872C214.537 35.7872 213.604 35.4081 212.743 34.6393Z",
    fill: "#2E83B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlika);
export default __webpack_public_path__ + "static/media/klika.327524534914a9af6b7eb3217cc7e6f0.svg";
export { ForwardRef as ReactComponent };